<template>
	<div class="styling-process-page">
    <input type="checkbox" name="sidebar-toggle" id="sidebar-toggle">
    <label for="sidebar-toggle" class="sidebar-toggler clickable">
      <span>&larr;</span>
    </label>
    <input type="checkbox" name="topbar-toggle" id="topbar-toggle" checked>
    <label data-testid="topbar-toggle" for="topbar-toggle" class="topbar-toggler clickable" :class="{ 'is-new': isNewSurvey}">
      <span>&#8593;</span>
    </label>
		<div class="styling-sidebar-wrapper">
      <side-bar
        :stylingBox="stylingBox"
        :complete="isComplete"
        @showBoxModal="showBoxModal"
        @updateCategory="updateCategory"
        @updateFilter="updateFilter"
        @clearFilter="clearFilter"
        @removeProduct="removeProduct"
        @editLetter="editLetter"
        @completeOrder="completeOrder"
        @selectProduct="selectProductInBox"
      />
    </div>
    <div class="topbar-wrapper" :class="{'is-new': isNewSurvey}">
      <customer-profile
        :survey="survey"
        :customer-info="customerInfo"
        :has-prev-orders="!!prevOrders.length"
        @openBodyTypeModal="openBodyTypeModal"
        :has-preshipping-feedback="!!preshippingFeedback.length"
        @showFeedbackSummary="showFeedbackSummaryModal"
        @showPrevModal="showPrevModal"
        @showCustomerComments="showCustomerCommentsModal"
        @showStylistComments="showStylistCommentsModal"
        @rescheduleCall="showRescheduleCallModal"
        @showPreshippingFeedback="showPreshippingFeedback"
        @showCustomerPhoto="showCustomerPhotoModal"
        @checkStock="checkStock"
        @sendPreshipping="checkBookedCallBeforeSendingSP"
        @recommender="onRecommender"
        :feedbackSummary ="feedbackSummary"
        :styling ="preshippingComment"
        v-if="isNewSurvey"
      />
      <top-bar
        :customer-info="customerInfo"
        :has-preshipping-feedback="preshippingFeedback.length ? true : false"
        :has-prev-orders="!!prevOrders.length"
        @showPrevModal="showPrevModal"
        @showCustomerComments="showCustomerCommentsModal"
        @showStylistComments="showStylistCommentsModal"
        @rescheduleCall="showRescheduleCallModal"
        @showPreshippingFeedback="showPreshippingFeedback"
        @showCustomerPhoto="showCustomerPhotoModal"
        @sendOldSurveyPSPreCheck="sendOldSurveyPSPreCheck"
        v-else
      />
      <div class="notify-wrapper flex align-center" v-if="notifyShow">
        <SvgFile name="error" v-if="notify.status === 'error'" color="#FE0006" />
        <SvgFile name="ok" v-if="notify.status === 'success'" color="#4DAA00" />
        <h2 class="no-margin very-small-margin-left" :class="notify.status">
          {{ notify.message }}
        </h2>
      </div>
    </div>
    <div class="main-wrapper">
      <div>
        <div class="flex flex-wrap filteredCategoryProducts">
          <div class="product-wrapper mainProdWrapper" v-for="product in windowedProducts" :key="product.id" @click="selectProduct(product)">
            <product-in-category
             style="width: 100%; max-width: 100%;height: 100%; max-height: auto;"
              :product="product"
              :styling-box="stylingBox"
              :in-box="false"
              @productClick="addToBox"
              :class="{ 'wrong-product': reasonFilteredProducts[product.id] || dislikedColorProducts[product.id] }"
              :filter-reason="reasonFilteredProducts[product.id] || dislikedColorProducts[product.id]"
            />
          </div>
        </div>
        <infinite-loading ref="infiniteLoadMore" @infinite="loadMoreProducts" v-if="hasMoreProducts" :distance="400">
          <div slot="no-more">
            ==*End of List*==
          </div>
          <div slot="no-results">
            No results
          </div>
        </infinite-loading>
      </div>
      <Loader class="extra-soft" :soft="true" v-if="softLoading && !pageLoading" />
    </div>
    <Loader :soft="true" v-if="pageLoading" />
    <vue-slideout-panel>
    </vue-slideout-panel>
    <styling-view-modal name="ViewBoxModal" v-if="boxModalShow" @close="boxModalShow = false" :summary="feedbackSummary" :survey="survey" :styling="preshippingComment" @removeBox="removeProducts">
      <div class="viewBoxModalContent">
        <div class="row flex flex-column small-margin-bottom">
          <h2 class="very-small-margin-bottom">Summary</h2>
          <span><strong>Styles:</strong> {{ stylesCount }}</span>
          <span><strong>Total:</strong> {{ totalPrice }}</span>
        </div>
        <div class="products-wrapper flex flex-column justify-content-center"
         v-for="(category, i) in filterStyles" :key="i">
          <div
            v-if="category.length"
            class="bold small-margin-top small-margin-bottom">{{ styling_category[i]}}</div>
          <div class="flex flex-wrap">
            <div v-for="product in category" :key="product.id" class="very-small-margin">
              <product
                :product="product"
                :in-box="true"
                :filter-reason="reasonFilteredProducts[product.id]"
                :feedback="product.feedback ? (product.feedback.accepted ? 'heart' : 'close') : null"
                :feedbackReason="product.feedback ? product.feedback.name: ''"
                :in-viewbox="true"
                :removedList="removeIds"
                @checkProduct="checkProduct"
              />
            </div>
          </div>
        </div>
      </div>
    </styling-view-modal>

    <modal name="productModal" v-if="productModalShow" @close="productModalShow = false" :modal-width="1200">
      <div v-click-outside="() => { productModalShow = false }">
        <div class="flex very-small-padding">
          <product-gallery :images="currentProduct.imagesList" />
          <div class="product-info-wrapper flex flex-column border full-width small-margin-left">
            <div class="border-top border-bottom bg-light-grey flex justify-content-between small-padding-top small-padding-bottom small-padding-right small-padding-left">
              <span>Style Name</span>
              <span>{{ currentProduct.style }}</span>
            </div>
            <div class="flex justify-content-between small-padding-top small-padding-bottom small-padding-right small-padding-left">
              <span>Description</span>
              <span style="padding-left: 10px;">{{ currentProduct.description }}</span>
            </div>
            <div class="border-top border-bottom bg-light-grey flex justify-content-between small-padding-top small-padding-bottom small-padding-right small-padding-left">
              <span>Price</span>
              <span class="text-orange">
                <span :class="{ 'line-through': currentProduct.price.discount_percentage }">
                  <span class="text-black">
                    {{ currentProduct.price | toCurrency }}
                  </span>
                </span>
                &nbsp;
                <strong v-if="currentProduct.price.discount_percentage">
                  {{ currentProduct.price.sales_price | toCurrency }}
                </strong>
              </span>
            </div>
            <div class="flex justify-content-between small-padding-top small-padding-bottom small-padding-right small-padding-left">
              <span>Fit</span>
              <span></span>
            </div>
            <div class="border-top border-bottom bg-light-grey flex justify-content-between small-padding-top small-padding-bottom small-padding-right small-padding-left">
              <span>Color</span>
              <span>{{ currentProduct.color.name }}</span>
            </div>
            <div class="flex justify-content-between small-padding-top small-padding-bottom small-padding-right small-padding-left">
              <span>Material</span>
              <span>{{ currentProduct.material }}</span>
            </div>
            <div class="border-top border-bottom bg-light-grey flex justify-content-between small-padding-top small-padding-bottom small-padding-right small-padding-left">
              <span>Product ID</span>
              <span>
                <router-link :to="{ path: `/product/${currentProduct.id}` }" target="_blank">
                  {{ currentProduct.id }}
                </router-link>
              </span>
            </div>
            <div class="flex justify-content-between small-padding-top small-padding-bottom small-padding-right small-padding-left">
              <span>SKU ID</span>
              <span>{{ currentProduct.sku }}</span>
            </div>
            <div class="border-top border-bottom bg-light-grey flex justify-content-between small-padding-top small-padding-bottom small-padding-right small-padding-left">
              <span>Size</span>
              <span>
                <select name="size" id="product-size" style="font-size: 15px;" class="uppercase" v-model="currentProduct.variantId">
                  <option v-for="size in currentProduct.variants" :key="size.id" :value="size.id">
                    {{ size.size }}
                  </option>
                </select>
              </span>
            </div>
            <div class="flex flex-column small-margin-top" v-if="productVote && productVote.counts">
              <div class="very-small-padding-top">
                <span>Product Size: </span>
              </div>

              <div class="very-small-padding-top very-small-padding-bottom">
                <button class="small-margin-right" @click="voteProduct('size', 'downsize')">Downsize({{ productVote.counts.size_vote.downsize }})</button>
                <button class="small-margin-right" @click="voteProduct('size', 'normal')">Normal({{ productVote.counts.size_vote.normal }})</button>
                <button @click="voteProduct('size', 'upsize')">Upsize({{ productVote.counts.size_vote.upsize }})</button>
              </div>

              <div class="very-small-padding-top">
                <span>Need to upsize by? </span>
              </div>

              <div class="very-small-padding-top">
                <span class="small-margin-right">By big bras?</span>
                <button class="small-margin-right" @click="voteProduct('top', 1)">
                  Yes({{ productVote.counts.upsize_top.yes }})
                </button>
                <button @click="voteProduct('top', 0)">
                  No({{ productVote.counts.upsize_top.no }})
                </button>
              </div>
              <div class="very-small-padding-top">
                <span class="small-margin-right">By big legs?</span>
                <button class="small-margin-right" @click="voteProduct('bottom', 1)">
                  Yes({{ productVote.counts.upsize_bottom.yes }})
                </button>
                <button @click="voteProduct('bottom', 0)">
                  No({{ productVote.counts.upsize_bottom.no }})
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="flex justify-content-between small-padding-right small-padding-left">
          <button class="bg-red" @click="productModalShow = false">Close</button>
          <button :class="isCurrentProductIn ? 'bg-red' : 'bg-green'" @click="handleAddRemove" :ref="'button-add-remove-' + currentProduct.id">
            {{ isCurrentProductIn ? 'Remove from Style' : 'Add to Style' }}
          </button>
        </div>
      </div>
    </modal>

    <modal name="prevOrderModal" v-if="prevOrderModalShow" @close="prevOrderModalShow = false" :modal-width="1200">
      <div v-click-outside="() => { prevOrderModalShow = false }">
        <prev-orders-modal ref="letterModalContent" :prev-orders="prevOrders" />
      </div>
    </modal>

    <modal name="customerCommentsModal" v-if="customerCommentsModalShow" @close="customerCommentsModalShow = false">
      <div v-click-outside="() => { customerCommentsModalShow = false }">
        <comments-modal :comments="customerInfo.customerComments" type="customer" />
      </div>
    </modal>


    <modal name="feedbackSummaryModal" class="feedbackSummaryModalClass stylingProcess" v-if="feedbackSummaryModalShow" @close="feedbackSummaryModalShow = false">
      <div v-click-outside="() => { feedbackSummaryModalShow = false }">
        <FeedbackSummaryModal :summary="feedbackSummary" :survey="survey" :styling="preshippingComment" type="customer" />
      </div>
    </modal>

    <modal name="stylistCommentsModal" v-if="stylistCommentsModalShow" @close="closeStylistCommentsModal">
      <div v-click-outside="closeStylistCommentsModal">
        <StylistCommentsModal :customer-id="customerInfo.id" type="stylist" ref="stylistCommentsModal" @close="closeStylistCommentsModal"/>
      </div>
    </modal>

    <modal name="preshippingFeedbackModal" class="preshippingFeedbackModalClass" v-if="preshippingFeedbackModalShow" @click="preshippingFeedbackModalShow = false">
      <div v-click-outside="() => { preshippingFeedbackModalShow = false }">
        <preshipping-feedback-modal :preshippingFeedback="preshippingFeedback" :preshipping-comment="preshippingComment" :preshippingQuizFeedback="preshippingQuizFeedback" />
      </div>
    </modal>

    <modal name="customerPhotoModal" v-if="customerPhotoModalShow" @close="customerPhotoModalShow = false">
      <!-- <div v-click-outside="() => { customerPhotoModalShow = false }"> -->
        <img :src="customerInfo.photo" class="full-width" />
      <!-- </div> -->
    </modal>

    <reschedule-call :id="customerInfo.scheduledCall.id" v-if="rescheduleCallModalShow" @success="rescheduleCallModalShow = false" @close="rescheduleCallModalShow = false" />

    <modal name="bodyTypeModal" v-if="bodyTypeModalShow" @close="bodyTypeModalShow = false" :modal-width="1000">
      <div v-click-outside="() => { bodyTypeModalShow = false }">
        <BodyTypeModal :bodyType="bodyType" />
      </div>
    </modal>

    <modal name="preCompleteModal" v-if="preCompleteModalShow" @close="preCompleteModalShow = false" :modal-width="380">
      <div v-click-outside="() => { preCompleteModalShow = false }">
        <PreCompleteModal @complete="data => completeOrder(data)" @close="preCompleteModalShow = false" />
      </div>
    </modal>

    <modal name="stockWarningModal" v-if="stockWarningModalShow" @close="stockWarningModalShow = false" :modal-width="1000">
      <div v-click-outside="() => { stockWarningModalShow = false }">
        <StockWarningModal :products="stockWarningProductsComputed" @remove="removeProduct" @close="stockWarningModalShow = false" />
      </div>
    </modal>

    <modal name="confirmCompleteModal" v-if="requestedNewPS" @close="requestedNewPS = false" :modal-width="380"
    >
      <div v-click-outside="() => { stockWarningModalShow = false;}">
        <ConfirmCompleteModal @close="requestedNewPS = false" @finalizeOrder="finalizeOrder" @complete="(data) => completeOrder(data)" />
      </div>
    </modal>

    <modal
      name="additionalPSPreCheck"
      v-if="additionalPSRequested"
      @close="handlePopupClose"
      :modal-width="380"
    >
      <div>
        <AdditionalPSPreCheck
          @close="additionalPSRequested = false"
          @handleModalConfirm="handleModalConfirm" />
      </div>
    </modal>
    <modal
      name="bookedCallCheckModal"
      v-if="scheduledCallCheck || checkBookedCallBeforeSP"
      @close="handleCallModalConfirm"
      :modal-width="380"
    >
      <div>
        <BookedCallCheckModal
          :message="bookedMessage"
          @handleSendSneakPeek = "sendPreshipping"
          @close="handleCloseBookCallModal"
          @handleModalConfirm="handleCallModalConfirm" />
      </div>
    </modal>

    <modal name="confirmSecondPSModal" v-if="showSecondPSConfirmModal" @close="showSecondPSConfirmModal = false" :modal-width="380"
    >
      <div v-click-outside="() => { stockWarningModalShow = false;}">
        <ConfirmSecondPSModal @close="showSecondPSConfirmModal = false" @confirmSendSecondPS="confirmSendSecondPS" />
      </div>
    </modal>

    <modal name="checkRecommenderModal" v-if="showRecommenderModal" @close="showRecommenderModal = false" :modal-width="380">
      <div>
        <RecommenderModal @close="showRecommenderModal = false" @confirmRecommender="confirmRecommender" />
      </div>
    </modal>

    <modal name="confirmOldSurveySecondPSModal" v-if="showOldSurveySecondPSModal" @close="showOldSurveySecondPSModal = false" :modal-width="380"
    >
      <div v-click-outside="() => { stockWarningModalShow = false;}">
        <ConfirmSecondPSModal @close="showOldSurveySecondPSModal = false" @confirmOldSurveySendSecondPS="confirmOldSurveySendSecondPS" />
      </div>
    </modal>

    <outfit-modal name="outfitsModal" v-if="outfitsModalShow" @close="outfitsModalShow = false" @completeOrder="confirmOutfit" :modal-width="1000">
      <div>
        <CustomerViewModal @close="outfitsModalShow = false" :outfitArray="outfitArray" />
      </div>
    </outfit-modal>
    <outfit-modal name="letterModal" v-if="letterModalShow" @close="letterModalShow = false" :feedbackSummary="feedbackSummary" :survey="survey" :styling="preshippingComment"  @completeOrder="completeOrder" @saveLetter="saveLetter" @resetLetter="resetLetter" :modal-width="1600" :isLetter="letterModalShow" :changedLetter="changedLetter">
      <div>
        <StylistLetterModal @changeLetter="changeLetter" @close="letterModalShow = false" @saveLetter="saveLetter" :saveLetter="changedLetter" :letter="letterContent" :locale="customerLocale.country" />
      </div>
    </outfit-modal>
	</div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios/index'
import InfiniteLoading from 'vue-infinite-loading'
import { VueSlideoutPanel } from 'vue2-slideout-panel'

import SideBar from '@/components/styling-process/SideBar.vue'
import TopBar from '@/components/styling-process/TopBar.vue'
import CustomerProfile from '@/components/styling-process/CustomerProfile.vue'
import Product from '@/components/styling-process/Product.vue'
import ProductInCategory from '@/components/styling-process/ProductInCategory.vue'
import CommentsModal from '@/components/styling-process/CommentsModal'
import FeedbackSummaryModal from '@/components/styling-process/FeedbackSummaryModal'
import PreshippingFeedbackModal from '@/components/styling-process/PreshippingFeedbackModal'
import BodyTypeModal from '@/components/styling-process/BodyTypeModal.vue'
import PreCompleteModal from '@/components/styling-process/PreCompleteModal.vue'
import StockWarningModal from '@/components/styling-process/StockWarningModal.vue'
import RescheduleCall from '@/components/scheduled-calls/Reschedule.vue'
import ConfirmCompleteModal from '@/components/styling-process/ConfirmCompleteModal.vue'
import AdditionalPSPreCheck from '@/components/styling-process/AdditionalPSPreCheck.vue'
import BookedCallCheckModal from '@/components/styling-process/BookedCallCheckModal.vue'
import ConfirmSecondPSModal from '@/components/styling-process/ConfirmSecondPSModal.vue'
import ConfirmOldSurveySecondPSModal from '@/components/styling-process/OldSurveySecondPSModal.vue'
import ProductGallery from '@/components/ProductGallery.vue'
import CutLetter from '@/components/styling-process/editletter/index.vue'
import CustomerViewModal from '@/components/styling-process/CustomerViewModal.vue'
import StylistLetterModal from '@/components/styling-process/StylistLetterModal.vue'
import RecommenderModal from '@/components/styling-process/RecommenderModal.vue'
import StylistCommentsModal from '@/components/styling-process/StylistCommentsModal.vue'

import { mapGetters } from 'vuex'
import StylingViewModal from '../components/StylingViewModal.vue'

Vue.component('cut-letter', CutLetter)

let loader

export default {
  name: 'StylingProcess',
  components: {
    SideBar,
    TopBar,
    CustomerProfile,
    Product,
    ProductInCategory,
    ProductGallery,
    CommentsModal,
    PreshippingFeedbackModal,
    BodyTypeModal,
    PreCompleteModal,
    StockWarningModal,
    RescheduleCall,
    InfiniteLoading,
    ConfirmCompleteModal,
    AdditionalPSPreCheck,
    BookedCallCheckModal,
    ConfirmSecondPSModal,
    ConfirmOldSurveySecondPSModal,
    VueSlideoutPanel,
    CutLetter,
    CustomerViewModal,
    StylistLetterModal,
    RecommenderModal,
    FeedbackSummaryModal,
    StylistCommentsModal,
    StylingViewModal
  },
  data () {
    return {
      order: null,
      customer: null,
      softLoading: false,
      // Full-screen loader for the initial page load. Stays up across the whole
      // created() fetch chain (order -> prerequisites -> styling -> products) so
      // the page never flashes blank between calls. Handed off to softLoading
      // once the product grid is fetched.
      pageLoading: true,
      orderId: null,
      boxModalShow: false,
      stylingBox: [],
      feedbackSummary: "",
      customerInfo: {},
      survey: null,
      colorMapping: null,
      sizeMapping: null,
      customerComments: [],
      stylistComments: [],
      orderComments: [],
      stylingProductCategories: [],
      filters: {
        currency: 1,
        colors: [],
        brands: [],
        sizes: [],
        categories: [],
        min_price: 0,
        max_price: 3500,
        material: [],
        material_percentage: ''
      },
      productModalShow: false,
      currentProduct: null,
      letterModalShow: false,
      prevOrders: [],
      returnedProducts: [],
      prevOrderModalShow: false,
      customerCommentsModalShow: false,
      stylistCommentsModalShow: false,
      feedbackSummaryModalShow: false,
      rescheduleCallModalShow: false,
      preshippingFeedbackModalShow: false,
      bodyTypeModalShow: false,
      productVote: null,
      stylingCategories: [],
      filteredProducts: [],
      preshippingFeedback: [],
      preshippingQuizFeedback: null,
      preshippingComment: null,
      customerPhotoModalShow: false,
      bodyType: {},
      dislikeColors: [],
      isNewSurvey: false,
      preCompleteModalShow: false,
      reason: '',
      // How many products are actually rendered (the DOM window). Grows on scroll
      // via loadMoreProducts. Keeps the initial paint small instead of dumping a
      // whole server page (~40 cards + animated loading GIFs) into the DOM at once.
      productsLength: 20,
      limit: 20,
      productsList: [],
      stockWarningModalShow: false,
      stockWarningProducts: [],
      notifyShow: false,
      notify: {
        status: 'success',
        message: 'Hello World'
      },
      additionalPSRequested: false,
      requestedNewPS: false,
      preshippingFeedBackLength: false,
      scheduledCallCheck: false,
      checkBookedCallBeforeSP: false,
      scheduledCall: null,
      bookedMessage: '',
      showSecondPSConfirmModal: false,
      showOldSurveySecondPSModal: false,
      outfitArray: {},
      outfitsModalShow: false,
      letterContent: {
        column_1: '',
        column_2: ''
      },
      customerLocale: null,
      changedLetter: false,
      isComplete: false,
      preshippingSent: false,
      styling_category: ['Lower wear', 'Upper wear', 'Overwear', 'Dresses', 'Accessories', 'Others'],
      showRecommenderModal: false,
      currentPage: 1,
      nextPage: false,
      removeIds: [],
      preshippingStylingFeedback: []
    }
  },
  computed: {
    ...mapGetters([
      'getTestStylist'
    ]),
    reasonFilteredProducts () {
      // Match on exact numeric id — the old `returnedProducts.toString().includes(key)`
      // did substring matching, so id 12 falsely matched 123, 512, etc.
      const returned = new Set(this.returnedProducts.map(Number))
      // Merge in the "Size not mentioned" tags that used to be written into
      // filteredProducts by the products() getter's side effect.
      const merged = { ...this.filteredProducts, ...this.sizeNotMentionedProducts }
      return Object.keys(merged)
        .reduce((obj, key) => {
          obj[key] = { reason: returned.has(Number(key)) ? 'Returned previously' : merged[key].reason, reason_code: merged[key].reason_code }
          return obj
        }, {})
    },
    products () {
      if (!this.customerInfo.sizes) return []
      return this.productsList.filter(product => {
        const sizeLabel = this.sizeMapping[product.category_id] || this.sizeMapping[product.subcategory_id]
        const wantedSize = this.customerInfo.sizes[sizeLabel]

        if (wantedSize === undefined) return true
        for (let i = 0; i < product.variants.length; i++) {
          const variant = product.variants[i]
          if (wantedSize >= variant.converted_size_range[0] && wantedSize <= variant.converted_size_range[1]) { return true }
        }
        return false
      })
    },
    // Products the customer never specified a size for. Previously computed by
    // mutating `filteredProducts` from inside the `products` getter (a Vue anti-
    // pattern that caused re-render cascades and non-reactive key writes). Now a
    // pure derived map, merged into `reasonFilteredProducts` and `filteredIDs`.
    sizeNotMentionedProducts () {
      if (!this.customerInfo.sizes) return {}
      return this.productsList.reduce((acc, product) => {
        const sizeLabel = this.sizeMapping[product.category_id] || this.sizeMapping[product.subcategory_id]
        if (this.customerInfo.sizes[sizeLabel] === undefined) {
          acc[product.id] = { reason: 'Size not mentioned' }
        }
        return acc
      }, {})
    },
    stylesCount () {
      return this.stylingBox.length;
    },
    totalPrice () {
      return Math.round(this.stylingBox.reduce((pv, cv) => pv + cv.price.regular_price, 0) * 100) / 100;
    },
    isCurrentProductIn () {
      return this.stylingBox.findIndex(el => (el.variantId == this.currentProduct.variantId)) >= 0;
    },
    filteredIDs () {
      return [
        ...Object.keys(this.filteredProducts).map(el => parseInt(el)),
        ...Object.keys(this.dislikedColorProducts).map(el => parseInt(el)),
        ...Object.keys(this.sizeNotMentionedProducts).map(el => parseInt(el))
      ]
    },
    filterSortedProducts () {
      return [...this.products].sort((a, b) => a.sortOrder < b.sortOrder ? -1 : (a.sortOrder > b.sortOrder ? 1 : 0))
        .sort((x, y) => this.filteredIDs.includes(x.id) - this.filteredIDs.includes(y.id))
    },
    // Only the first `productsLength` sorted products are rendered; the rest are
    // buffered in `products`/`productsList` and revealed as the user scrolls.
    windowedProducts () {
      return this.filterSortedProducts.slice(0, this.productsLength)
    },
    // Keep the infinite-loader mounted while there are buffered products still to
    // reveal OR more server pages to fetch. (The loader resets via this v-if
    // remount, so it must go false only when truly nothing is left.)
    hasMoreProducts () {
      return this.nextPage || this.productsLength < this.filterSortedProducts.length
    },

    filterStyles () {
      const sorted = new Array()
      for (var i = 0; i < 6; i++) {
        sorted[i] = new Array()
      }
      for (const index in this.stylingBox) {
        const category = this.stylingCategories.filter((cate) => cate.product_categories.includes(this.stylingBox[index].category_id))
        const feedback = this.preshippingFeedback.find(el => el.product.id === this.stylingBox[index].id && el.variant_id === this.stylingBox[index].variantId)
        if (category.length > 0) {
          switch (category[0].name) {
            case 'Pants':
            case 'Leggings':
            case 'Skirts':
              sorted[0].push({
                ...this.stylingBox[index],
                feedback
              })
              break
            case 'Upperwear':
              sorted[1].push({
                ...this.stylingBox[index],
                feedback
              })
              break
            case 'Overwear':
              sorted[2].push({
                ...this.stylingBox[index],
                feedback
              })
              break
            case 'Dress':
              sorted[3].push({
                ...this.stylingBox[index],
                feedback
              })
              break
            case 'Accessories':
              sorted[4].push({
                ...this.stylingBox[index],
                feedback
              })
              break
          }
        } else {
          sorted[5].push({
            ...this.stylingBox[index],
            feedback
          })
        }
      }
      return sorted
    },
    dislikedColorProducts () {
      return this.products.filter(product => this.dislikeColors.findIndex(el => el.id === product.color.id) !== -1)
        .map(product => ({ id: product.id, reason: 'Dislike: ' + this.dislikeColors.find(el => el.id === product.color.id).name }))
        .reduce((obj, item) => {
          return {
            ...obj,
            [item.id]: { reason: item.reason, reason_code: 'dislikes_color' }
          }
        }, {})
    },
    stockWarningProductsComputed () {
      return this.stylingBox.filter(el => this.stockWarningProducts.includes(el.variantId));
    }
  },
  methods: {
    getOrder (orderId) {
      return new Promise((resolve, reject) => {
        Vue.api.get(`order/${orderId}?format=simple`, {}, {
          callback: (res) => {
            this.order = res
            resolve(res)
          },
          error: err => {
            reject(err)
          }
        })
      })
    },
    showPanel () {
          const width = window.innerWidth * 0.85
          const panelHandler = this.$showPanel({
            component: 'cut-letter',
            openOn: 'right',
            keepAlive: false,
            width: width,
            props: {
              styling_model_categories: this.stylingProductCategories,
              feedbackSummary: this.feedbackSummary,
              survey: this.survey,
              styling: this.preshippingComment
            }
          })

          panelHandler.promise.then(result => {
            if (result.confirm) {
                this.getNewLetters();
                setTimeout(() => {
                  this.letterModalShow = true
                }, 300)
              } else {
                // check complete button when close Panel
                this.lastOutfits().then(result => {
                  this.isComplete = result
                }).catch(() => {
                  this.isComplete = false
                })
              }
          })
    },
    resetLetter () {
      loader = this.$loading.show()
      setTimeout(() => {
        this.deleteLetter().then(() => {
          loader.hide()
          Vue.api.get(`order/${this.orderId}/letter`, {}, {
            before: () => loader = this.$loading.show(),
            always: () => loader.hide(),
            callback: (data) => {
              this.letterContent = data
            }
          })
        })
      }, 1000)
    },
    deleteLetter () {
      return new Promise((resolve, reject) => {
        Vue.api.delete(`order/${this.orderId}/letter`, {}, {
          callback: (data) => {
            resolve(true)
          },
          error: err => {
            reject(err)
          }
        })
      })
    },
    getNewLetters () {
      Vue.api.get(`order/${this.orderId}/letter`, {}, {
        before: () => loader = this.$loading.show(),
        always: () => loader.hide(),
        callback: (data) => {
          this.letterContent = data
        }
      })
    },
    checkProduct (pid) {
      const index = this.removeIds.indexOf(pid)
      if (index > -1) {
        this.removeIds.splice(index, 1)
      } else {
        this.removeIds.push(pid)
      }
    },
    removeProducts () {
      Vue.api.delete(`/order/${this.orderId}/product`, {
        variant_ids: this.removeIds
      }, {
        before: () => this.softLoading = true,
        always: () => this.softLoading = false,
        callback: res => {
          this.removeIds.forEach(pid => {
            this.stylingBox.splice(this.stylingBox.findIndex(el => (el.variantId === pid)), 1)
            this.$store.commit('setStylingBox', this.stylingBox);
          })
          this.removeIds = []
        },
        error: (error) => {
          console.error('Error in Remove product: ', error)
          this.softLoading = false
        }
      })
    },
    updateProducts (filters = { currency: 1 }) {
      this.softLoading = true
      this.fetchFilter(filters).then((res) => {
        if (res.next_page_url) {
          const nextPage = new URL(res.next_page_url).searchParams.get('page')
          this.currentPage = Number(nextPage)
          this.nextPage = true
        } else {
          this.nextPage = false
        }

        this.softLoading = false
        if (res && Object.values(res.data).length > 0) {
          this.$store.commit('setUserCurrencyId', Object.values(res.data)[0].price.currency_id)
        }

        const temp = res.data
        this.productsList = Object.values(temp).map(product => {
          let mats = []
          try {
            mats = JSON.parse(product.material)
          } catch (e) {}
          return {
            ...product,
            variants: Object.values(product.variants),
            material: (mats === null || mats === undefined) ? [] : mats.map(m => `${m.percentage}% ${m.name}`).join(', ')
          }
        }).sort((a, b) => a.sortOrder > b.sortOrder ? -1 : (a.sortOrder < b.sortOrder ? 1 : 0))

        // Products are in — the initial page load is complete.
        this.pageLoading = false
      }).catch(() => {
        // Never leave a loader spinning if the product fetch fails.
        this.softLoading = false
        this.pageLoading = false
      })
    },
    fetchFilter (filters = { currency: 1 }) {
      return new Promise((resolve, reject) => {
        Vue.api.post(`/v2/product/filter?page=${this.currentPage}`, {
          ...filters,
          materials: filters.material
        }, {
          callback: (res) => {
            if (res.data) resolve(res)
            else reject(res.status)
          },
          // Without this, a network/HTTP failure never fires the callback, so the
          // promise never settles and the page loader spins forever.
          error: (err) => reject(err)
        })
      })
    },
    loadMoreProducts ($state) {
      // 1) Reveal already-buffered products first — no network call needed.
      if (this.productsLength < this.filterSortedProducts.length) {
        this.productsLength += this.limit
        if (this.productsLength >= this.filterSortedProducts.length && !this.nextPage) {
          // Window has caught up to the buffer and there are no more server pages.
          $state.complete()
        } else {
          $state.loaded()
        }
        return
      }

      // 2) Buffer exhausted and no more server pages — done.
      if (!this.nextPage) {
        $state.complete()
        return
      }

      // 3) Fetch the next server page, append it to the buffer, reveal a chunk.
      this.fetchFilter(this.filters).then((res) => {
        if (res.next_page_url) {
          this.currentPage = Number(new URL(res.next_page_url).searchParams.get('page'))
          this.nextPage = true
        } else {
          this.nextPage = false
        }

        const temp = res.data
        if (Object.values(temp).length > 0) {
          const productList = Object.values(temp).map(product => {
            let mats = []
            try {
              mats = JSON.parse(product.material)
            } catch (e) {}
            return {
              ...product,
              variants: Object.values(product.variants),
              material: (mats === null || mats === undefined) ? [] : mats.map(m => `${m.percentage}% ${m.name}`).join(', ')
            }
          }).sort((a, b) => a.sortOrder > b.sortOrder ? -1 : (a.sortOrder < b.sortOrder ? 1 : 0))

          this.productsList = [...this.productsList, ...productList]
          this.productsLength += this.limit
          $state.loaded()
        } else {
          this.nextPage = false
          $state.complete()
        }
      }).catch(() => {
        $state.complete()
      })
    },
    updateCategory (value) {
      if (value > 0) this.filters.categories = [value]
      else this.filters.categories = []
      this.productsLength = 20
      this.currentPage = 1
      window.scrollTo(0, 0)
      this.updateProducts(this.filters)
    },
    updateFilter (data) {
      this.filters[data.label] = data.value
      this.productsLength = 20
      this.currentPage = 1
      window.scrollTo(0, 0)
      this.updateProducts(this.filters)
    },
    clearFilter () {
      this.filters.colors = []
      this.filters.brands = []
      this.filters.sizes = []
      this.filters.min_price = 0
      this.filters.max_price = 3500
      this.filters.material = []
      this.filters.tags = []
      this.filters.material_percentage = ''
      this.productsLength = 20

      this.currentPage = 1
      window.scrollTo(0, 0)
      this.updateProducts(this.filters)
    },
    addToBox (product, pid = null) {
      let variants
      if (pid === null) {
        pid = product.variants[0].id
        Vue.api.post(`/order/${this.orderId}/product/${pid}/autosize`, {}, {
          before: () => this.softLoading = true,
          always: () => this.softLoading = false,
          callback: res => {
            pid = res.id
            variants = product.variants.find(variant => variant.id === pid)
            const thumbnailVal = product.allImages !== undefined && product.allImages.length
                  ? product.allImages.find((el) => el.is_primary).urls.original ||
                    product.allImages[0].urls.original
                  : product.images.thumbnail

            this.stylingBox.push({
              ...product,
              variantId: pid,
              variants: variants,
              filteredReason: this.filteredProducts[product.id],
              thumbnail: thumbnailVal,
              subcategory_info: this.$store.state.stylingCategories.filter(item => item.id === product.subcategory_id)
            })
            this.$store.commit('setStylingBox', this.stylingBox);
          }
        })
      } else {
        variants = product.variants.find(variant => variant.id === pid)
        Vue.api.post(`/styling/order/${this.orderId}/product/${pid}`, {}, {
          before: () => this.softLoading = true,
          always: () => this.softLoading = false,
          callback: res => {
            this.stylingBox.push({
              ...product,
              variantId: pid,
              variants: variants,
              filteredReason: this.filteredProducts[product.id],
              thumbnail: product.allImages !== undefined && product.allImages.length
                  ? product.allImages.find((el) => el.is_primary).urls.original ||
                    product.allImages[0].urls.original
                  : product.images.thumbnail,
              subcategory_info: this.$store.state.stylingCategories.filter(item => item.id === product.subcategory_id)
            })
            this.$store.commit('setStylingBox', this.stylingBox);

            if (this.currentProduct.id) this.$refs['button-add-remove-' + this.currentProduct.id].disabled = false
          }
        })
      }
    },
    removeProduct (pid) {
      Vue.api.delete(`/styling/order/${this.orderId}/product/${pid}`, {
        styling: 1
      }, {
        before: () => this.softLoading = true,
        always: () => this.softLoading = false,
        callback: res => {
          this.stylingBox.splice(this.stylingBox.findIndex(el => (el.variantId === pid)), 1);
          this.$store.commit('setStylingBox', this.stylingBox);

          if (this.currentProduct && this.currentProduct.id) {
            this.$refs['button-add-remove-' + this.currentProduct.id].disabled = false
          }
        }
      })
    },
    selectProperSize (product) {
      const sizeLabel = this.sizeMapping[product.category_id] || this.sizeMapping[product.subcategory_id]
      const wantedSize = this.customerInfo.sizes[sizeLabel]

      let variantId

      if (wantedSize === undefined) {
        variantId = product.variants[0].id
      } else {
        for (let i = 0; i < product.variants.length; i++) {
          const variant = product.variants[i]
          if (wantedSize >= variant.converted_size_range[0] && wantedSize <= variant.converted_size_range[1]) {
            variantId = variant.id
            break
          }
        }
      }
      this.currentProduct = { ...product, variantId: variantId, imagesList: [] }
    },
    selectProduct (product) {
      if (!product.variantId) this.selectProperSize(product)

      const slug = product.slug.split('/')[2]

      // Keep one loader up until both requests resolve, then open the modal —
      // so it never opens before productVote is ready.
      loader = this.$loading.show()

      const votePromise = Vue.api.get(`/product/${product.id}/vote`, {}, {
        callback: res => {
          this.productVote = res
        }
      })
      const slugPromise = Vue.api.get(`/product-slug/${slug}`, {}, {
        callback: res => {
          this.currentProduct.imagesList = res.images
          this.currentProduct.style = res.style
          this.currentProduct.description = res.description
        }
      })

      Promise.all([votePromise, slugPromise]).then(() => {
        loader.hide()
        this.productModalShow = true
      }).catch(() => {
        loader.hide()
      })
    },
    selectProductInBox (product) {
      const findInProductsList = this.products.find(prod => (prod.id === product.id))
      this.currentProduct = { ...product, variants: findInProductsList ? findInProductsList.variants : [product.variants] }
      this.selectProduct(product)
    },
    handleAddRemove () {
      this.$refs['button-add-remove-' + this.currentProduct.id].disabled = true
      if (this.isCurrentProductIn) {
        this.removeProduct(this.currentProduct.variantId)
      } else {
        this.addToBox(this.currentProduct, this.currentProduct.variantId)
      }
    },
    /**
     * @see https://app.clickup.com/t/2w4by2z?comment=990052710
     * Test instructions for edit letter
     */
    editLetter () {
        this.showPanel();
    },
    /**
     * @see https://app.clickup.com/t/2w4bxhu
     * Relevant for fix of change letter
     */
    changeLetter () {
      this.changedLetter = true
    },
    saveLetter () {
      this.changedLetter = false
      // check complete button when save letter
      this.lastOutfits().then(result => {
        this.isComplete = result
      }).catch(() => {
        this.isComplete = false
      })
    },
    confirmOutfit () {
      this.outfitsModalShow = false
      setTimeout(() => {
        this.letterModalShow = true
      }, 300)
    },
    showPrevModal (prevOrders) {
      const routeData = this.$router.resolve({ path: '/stylings/prev-orders', query: { order_id: this.orderId } })
      window.open(routeData.href, '_blank')
    },
    showFeedbackSummaryModal () {
      loader = this.$loading.show()
      setTimeout(() => {
        loader.hide()
        this.feedbackSummaryModalShow = true
      }, 100)
    },
    showCustomerCommentsModal () {
      loader = this.$loading.show()
      setTimeout(() => {
        loader.hide()
        this.customerCommentsModalShow = true
      }, 100)
    },
    showStylistCommentsModal () {
      loader = this.$loading.show()
      setTimeout(() => {
        loader.hide()
        this.stylistCommentsModalShow = true
      }, 100)
    },
    showPreshippingFeedback () {
      loader = this.$loading.show()
      setTimeout(() => {
        loader.hide()
        this.preshippingFeedbackModalShow = true
      }, 100)
    },
    handleCallModalConfirm () {
      if (this.checkBookedCallBeforeSP) {
        this.checkBookedCallBeforeSP = false
        return
      }
      if (this.preshippingFeedBackLength && !this.additionalPSRequested) {
        this.showPreshippingFeedback()
      }
      this.scheduledCallCheck = false
    },
    handleModalConfirm () {
      this.showPreshippingFeedback()
      this.additionalPSRequested = false
    },
    handlePopupClose () {
      if (this.preshippingFeedBackLength && this.preshippingFeedBackLength === true) {
        this.showPreshippingFeedback()
        this.additionalPSRequested = false
      }
    },
    checkBookedCallBeforeSendingSP () {
      if (this.scheduledCall) {
        this.bookedMessage = "This customers has booked a call, Are you sure you'd like to send her a Sneak Peek?"
        this.checkBookedCallBeforeSP = true
      } else {
        this.sendPreshipping()
      }
    },
    handleCloseBookCallModal () {
      this.bookedMessage = ''
      if (this.scheduledCallCheck) this.scheduledCallCheck = false
      if (this.checkBookedCallBeforeSP) this.checkBookedCallBeforeSP = false
    },
    sendPreshipping () {
      if (this.checkBookedCallBeforeSP) this.checkBookedCallBeforeSP = false
      Vue.api.get(
        `/order/${this.orderId}/preshipping-status`,
        {},
        {
          before: () => (loader = this.$loading.show()),
          always: () => loader.hide(),
          callback: (res) => {
            if (this.preshippingSent) {
              this.showSecondPSConfirmModal = true
            } else {
              this.sendGeneralPS()
            }
          },
          error: (err) => {
            alert(err.data.message)
          }
        }
      )
    },
    onRecommender () {
      this.checkRecommendCount().then(result => {
        if (result) {
          this.showRecommenderModal = true
        } else {
          this.confirmRecommender()
        }
      }).catch(error => {
        alert(error.data.message)
      })
    },
    checkRecommendCount () {
      return new Promise((resolve, reject) => {
        Vue.api.get(`/order/${this.orderId}/recommendation/count`, {}, {
          callback: (res) => {
            resolve(res.styling > 0)
          },
          error: err => {
            reject(err)
          }
        })
      })
    },
    confirmRecommender () {
      this.recommender()
      this.showRecommenderModal = false
    },
    recommender () {
      Vue.api.post(
        `/order/${this.orderId}/styling/recommendation`,
        {},
        {
          before: () => (loader = this.$loading.show()),
          always: () => loader.hide(),
          callback: (res) => {
            this.updateStylist()
          },
          error: (err) => {
            alert(err.data.message)
          }
        }
      )
    },
    confirmSendSecondPS () {
      this.sendGeneralPS()
      this.showSecondPSConfirmModal = false
    },
    sendGeneralPS () {
      Vue.api.get(
        `/warehouse/order/${this.orderId}/check-item-stock`,
        {},
        {
          before: () => (loader = this.$loading.show()),
          always: () => loader.hide(),
          callback: (res) => {
            Vue.api.patch(
              `preshipping/${this.orderId}/reset-flow`,
              {},
              {
                before: () => (loader = this.$loading.show()),
                always: () => loader.hide(),
                callback: (res) => {
                  Vue.api.post(
                    `order/${this.orderId}/send-preshipping-email`,
                    {},
                    {
                      before: () => (loader = this.$loading.show()),
                      always: () => loader.hide(),
                      callback: () => {
                        this.preshippingSent = true
                        this.showNotify({
                          status: 'success',
                          message: 'Sneak Peek SMS sent'
                        })
                      },
                      error: (error) => {
                        this.showNotify({
                          status: 'error',
                          message: error.data.message
                        })
                      }
                    }
                  )
                },
                error: (error) => {
                  console.error('Error in SP reset flow: ', error)
                }
              }
            )
          },
          error: (error) => {
            if (error.data.error === 'products_out_of_stock') {
              loader.hide()
              this.showStockWarningModal(error.data.data)
            } else {
              alert(error.data.message)
            }
          }
        }
      )
    },
    sendOldSurveyPSPreCheck () {
      Vue.api.get(
        `/order/${this.$route.query.id}/preshipping-status`,
        {},
        {
          before: () => (loader = this.$loading.show()),
          always: () => loader.hide(),
          callback: (res) => {
            if (this.preshippingSent) {
              this.showSecondPSConfirmModal = true
            } else {
              this.sendGeneralPS()
            }
          },
          error: (err) => {
            alert(err.data.message)
          }
        }
      )
    },
    confirmOldSurveySendSecondPS () {
      this.sendPreshippingEmail()
      this.showSecondPSConfirmModal = false
    },
    sendPreshippingEmail () {
      Vue.api.patch(
          `preshipping/${this.$route.query.id}/reset-flow`,
          {},
          {
            before: () => (loader = this.$loading.show()),
            always: () => loader.hide(),
            callback: (res) => {
              Vue.api.post(`order/${this.$route.query.id}/send-preshipping-email`, {}, {
                before: () => this.clickedButton = 'preshipping',
                always: () => this.clickedButton = '',
                callback: () => {
                  this.showNotify({ status: 'success', message: 'Sneak Peek email sent' })
                },
                error: (error) => {
                  console.error('Error in SP reset flow: ', error)
                }
              })
            },
            error: error => {
              this.showNotify({ status: 'error', message: error.data.message })
            }
          }
      )
    },
    showNotify (notify) {
      this.notify = notify
      this.notifyShow = true
      setTimeout(() => {
        this.notify = { status: '', message: '' }
        this.notifyShow = false
      }, 3000)
    },
    checkStock () {
      Vue.api.get(`/warehouse/order/${this.orderId}/check-item-stock`, {}, {
        before: () => loader = this.$loading.show(),
        always: () => loader.hide(),
        callback: res => {
          loader.hide()
          this.showStockWarningModal([])
        },
        error: error => {
          console.error('error data', error.data.data)
          if (error.data.error === 'products_out_of_stock') {
            loader.hide()
            this.showStockWarningModal(error.data.data)
          } else {
            alert(error.data.message)
          }
        }
      })
    },
    voteProduct (category, vote) {
      Vue.api.post(`/product/${this.currentProduct.id}/vote`, {
        category,
        vote
      }, {
        before: () => loader = this.$loading.show(),
        always: () => loader.hide(),
        callback: res => {
          switch (category) {
            case 'size':
              this.productVote.counts.size_vote = { downsize: 0, normal: 0, upsize: 0 }
              this.productVote.counts.size_vote[vote] = 1
              break
            default:
              this.productVote.counts['upsize_' + category] = vote ? { yes: 1, no: 0 } : { yes: 0, no: 1 }
              break
          }
        }
      })
    },
    showRescheduleCallModal () {
      loader = this.$loading.show()
      setTimeout(() => {
        loader.hide()
        this.rescheduleCallModalShow = true
      }, 100)
    },
    showBoxModal () {
      loader = this.$loading.show()
      setTimeout(() => {
        loader.hide()
        this.removeIds = []
        this.boxModalShow = true
      }, 100)
    },
    showCustomerPhotoModal () {
      setTimeout(() => {
        this.customerPhotoModalShow = true
      }, 10)
    },
    updateStylist () {
      return new Promise((resolve, reject) => {
        Vue.api.get(`order/${this.orderId}/styling`, {}, {
          before: () => loader = this.$loading.show(),
          always: () => loader.hide(),
          callback: res => {
            if (res.products) {
              this.stylingBox = Object.values(res.products).map(product => {
                try {
                    if(product.material !== null) {
                        const matTemp = JSON.parse(product.material)
                        product.material = typeof matTemp !== 'boolean' && matTemp.reduce((ac, cv) => (ac + `${cv.percentage}% ${cv.name}, `), '')
                    }
                } catch (error) {
                  console.error('JSON Error: ', error)
                }
                return {
                  ...product,
                  variants: Object.values(product.variants)[0],
                  filteredReason: this.filteredProducts[product.id]
                }
              })
            }
            resolve(this.stylingBox)
          },
          error: err => {
            reject(err)
          }
        })
      })
    },
    /**
     * @see https://app.clickup.com/t/2xqu9xj
     * Relevant to check letter and outfit from outfits API
     */
    lastOutfits () {
      return new Promise((resolve, reject) => {
        this.stylingBox.map(style => {
          style.outfits = [];
          return style;
        })
        Vue.api.get(`order/${this.$route.query.id}/outfits`, {}, {
          callback: (data) => {
            const { outfits, order_letter_content, customer } = data
            this.customerLocale = customer.locale
            for (const outfitIndex in outfits) {
              const arr = outfits[outfitIndex];
              for (const key in arr) {
                this.stylingBox.map(style => {
                  if (style.variantId === arr[key].variant.id) {
                    style.outfits = [outfitIndex];
                  }
                  return style;
                })
              }
            }
            const checkOutfit = Object.values(this.stylingBox).filter(style => style.outfits === undefined || (style.outfits && style.outfits.length === 0))
            const qrcodePos = order_letter_content && order_letter_content.column_2.indexOf('qrCodeView')
            if (checkOutfit.length === 0 && qrcodePos > 0) {
              if (order_letter_content.column_1.indexOf('[') > 0 || order_letter_content.column_1.indexOf(']') > 0) {
                reject(new Error('Remember to remove the template square brackets from the letter.'))
              } else {
                resolve(true)
              }
            } else {
              if (checkOutfit.length > 0) {
                reject(new Error('Some styles have not been assigned to any outfits or single styles.'))
              }
              if (!qrcodePos || qrcodePos < 0) {
                reject(new Error('You need to save the letter.'))
              }
            }
          }
        })
      })
    },
    checkPreshippingFlow () {
      return new Promise((resolve, reject) => {
        Vue.api.get(`/preshipping/${this.orderId}/check-preshipping-flow`, {}, {
          callback: (res) => {
            if (res.status) resolve(res.status)
            else reject(res.status)
          }
        })
      })
    },
    checkPreconditions () {
      return new Promise((resolve, reject) => {
        Vue.api.get(`/order/${this.orderId}/styling/finish/preconditions`, {}, {
          callback: (res) => {
            if (!res.called && !res.pre_shipping_sent) resolve(res)
            else reject(res)
          }
        })
      })
    },
    finishStyling () {
      return new Promise((resolve, reject) => {
        Vue.api.post(`/order/${this.orderId}/styling/finish`, { push_to_warehouse: true }, {
          callback: (res) => {
            resolve(res)
          },
          error: (error) => {
            reject(error)
          }
        })
      })
    },
    /**
     * @see https://app.clickup.com/t/2xquatd?comment=1333537317
     * Relevant to fixing long chain issue
     */
    completeOrder (preConditionCheck = true) {
      if (preConditionCheck) {
        this.lastOutfits().then(result => {
          this.letterModalShow = false
          loader = this.$loading.show()
          this.checkPreshippingFlow().then(res => {
            this.requestedNewPS = true
            loader.hide()
          }).catch(() => {
            this.checkPreconditions().then(res => {
              this.preCompleteModalShow = 1
              loader.hide()
            }).catch(() => {
              this.finishStyling().then(res => {
                setTimeout(() => {
                  loader.hide()
                  this.$router.push({ path: '/scheduled-calls/stylist' })
                }, 1000)
              }).catch(error => {
                loader.hide()
                if (error.data.reason === 'products_out_of_stock') {
                  this.showStockWarningModal(error.data.data)
                } else {
                  alert(error.data.message)
                }
              })
            })
          })
        }).catch((error) => {
          alert(error.message)
        })
      } else {
        this.preCompleteModalShow = false
        loader = this.$loading.show()
        this.finishStyling().then(res => {
          setTimeout(() => {
            loader.hide()
            this.$router.push({ path: '/scheduled-calls/stylist' })
          }, 1000)
        }).catch(error => {
          loader.hide()
          if (error.data.reason === 'products_out_of_stock') {
            this.showStockWarningModal(error.data.data)
          } else {
            alert(error.data.message)
          }
        })
      }
    },
    finalizeOrder () {
      this.preCompleteModalShow = false

      Vue.api.post(`/order/${this.orderId}/styling/finish`, { push_to_warehouse: true }, {
        before: () => loader = this.$loading.show(),
        always: () => loader.hide(),
        callback: res => {
          setTimeout(() => {
            this.$router.push({ path: '/scheduled-calls/stylist' })
          }, 1000)
        },
        error: error => {
          if (error.data.reason === 'products_out_of_stock') {
            loader.hide()
            this.showStockWarningModal(error.data.data)
          } else {
            alert(error.data.message)
          }
        }
      })
    },
    showStockWarningModal (data) {
      loader = this.$loading.show()
      setTimeout(() => {
        loader.hide()
        this.stockWarningProducts = data
        this.stockWarningModalShow = true
      }, 100)
    },

    closeStylistCommentsModal () {
      this.$refs.stylistCommentsModal.updateAllStylistComments()
      this.stylistCommentsModalShow = false
    },
    openBodyTypeModal (bodyType) {
      this.bodyType = bodyType
      setTimeout(() => {
        this.bodyTypeModalShow = true
      }, 100)
    },
    getFeedbackSummary() {
        Vue.api.get(`customer/${this.order.customer_id}/feedback`, {}, {
            callback: res => {
                this.feedbackSummary = res.feedback;
            }
          })
    },
    getStyling () {
      Vue.api.get(`order/${this.orderId}/styling`, {}, {
        callback: res => {
          if (res.is_shipped) {
            alert('Order has already been shipped')
          }
          Vue.api.get(`/order/${this.orderId}/previous-styling-orders`, {}, {
            callback: res => {
              this.prevOrders = res
              res.forEach((order) => {
                order.products.forEach(product => {
                  const checkId = this.returnedProducts.filter(el => el === product.product_id)
                  if (checkId.length === 0 && product.qty_returned === 1) {
                    this.returnedProducts.push(product.product_id)
                  }
                })
              })
            }
          })
          this.filters.currency = this.customer.locale.currency_id || 1

          this.updateProducts(this.filters)

          this.isNewSurvey = this.survey.is_new_survey

          this.customerInfo = {
            ...this.customer,
            ...this.survey,
            sizes: {
              ...this.survey.sizes,
              lower: this.survey.is_new_survey ? this.survey.sizes.lower : this.survey.sizes.trousers
            },
            customerComments: this.customerComments,
            stylistComments: this.stylistComments,
            scheduledCall: res.scheduled_call,
            photo: this.survey.is_new_survey ? this.survey.image : null
          }
          this.scheduledCall = res.scheduled_call
          /**
           * see https://app.clickup.com/t/31g0vf5
           * Relevant for fix scheduled a call
           */
          if (res.scheduled_call) {
            var time = ((new Date(res.scheduled_call.call_at).getTime()) - (new Date().getTime())) / 1000
            if (time > 0) {
              this.scheduledCallCheck = true
            }
          }

          this.preshippingFeedback = res.preshipping_feedback.map(feedback => {
            try {
                if(feedback.product.material !== null) {
                    const matTemp = JSON.parse(feedback.product.material)
                    feedback.product.material = typeof matTemp !== 'boolean' && matTemp.reduce((ac, cv) => (ac + `${cv.percentage}% ${cv.name}, `), '')
                }
            } catch (e) {
              // this is when material is null or string
            }
            return feedback
          })

          this.preshippingQuizFeedback = res.preshipping_quiz_feedback

          for (const prop in this.preshippingQuizFeedback) {
            if (prop === 'dislike' || prop === 'liked' || prop === 'liked_to_box') {
              this.preshippingQuizFeedback[prop] = this.preshippingQuizFeedback[prop].map(product => {
                try {
                    if(product.product.material !== null) {
                        const matTemp = JSON.parse(product.product.material)
                        product.product.material = typeof matTemp !== 'boolean' && matTemp.reduce((ac, cv) => (ac + `${cv.percentage}% ${cv.name}, `), '')
                    }
                } catch (e) {
                  // this is when material is null or string
                }
                const products = product.product
                if (products) {
                  product.product = {
                    ...products,
                    variants: Object.values(products.variants)[0]
                  }
                }
                return product
              })
            }
          }
          this.preshippingSent = res.preshipping_sent

          if (res.preshipping_feedback.length) {
            this.preshippingFeedBackLength = true
            // Guard against firing with an undefined order id (would hit
            // /preshipping/undefined/check-preshipping-flow and 500).
            if (this.orderId) {
              Vue.api.get(
                `/preshipping/${this.orderId}/check-preshipping-flow`,
                {},
                {
                  callback: (res) => {
                    if (res.status === true) {
                      /**
                       * see https://app.clickup.com/t/31g0vf5
                       * Relevant for fix popup of another sneak peek request
                       */
                      this.additionalPSRequested = res.status && !this.scheduledCallCheck
                    } else {
                      this.showPreshippingFeedback()
                    }
                  }
                }
              )
            }
          } else {
            this.preshippingFeedBackLength = false
            if (this.orderId) {
              Vue.api.get(
                `/preshipping/${this.orderId}/check-preshipping-flow`,
                {},
                {
                  callback: (res) => {
                    this.additionalPSRequested = res.status
                  }
                }
              )
            }
          }

          this.filteredProducts = Object.values(res.filtered_products).length > 0 ? res.filtered_products
            : Object.values(res.filtered_products).reduce((p, acc) => {
              acc[p.product_id] = p
              return acc
            }, {})

          this.preshippingFeedback.filter(el => el.accepted === 0).map(el => {
            this.filteredProducts[el.product_id] = {
              reason: el.name,
              reason_code: el.label
            }
          })

          if (res.products) {
            this.stylingBox = Object.values(res.products).map(product => {
              try {
                if(product.material !== null) {
                    const matTemp = JSON.parse(product.material)
                    product.material = typeof matTemp !== 'boolean' && matTemp.reduce((ac, cv) => (ac + `${cv.percentage}% ${cv.name}, `), '')
                }
              } catch (error) {
                // console.log('error: ', error)
              }
              return {
                ...product,
                variants: Object.values(product.variants)[0],
                filteredReason: this.filteredProducts[product.id],
                thumbnail: product.allImages.length
                  ? product.allImages.find((el) => el.is_primary).urls.original ||
                    product.allImages[0].urls.original
                  : product.images.thumbnail
              }
            })
          }

          this.$store.commit('setStylingBox', this.stylingBox);

          this.stylingCategories = [...this.stylingProductCategories, { name: 'Asorted', product_categories: [] }];
          this.$store.commit('setStylingProductCategories', this.stylingCategories);

          this.preshippingStylingFeedback = [...res.preshipping_feedback, ...res.preshipping_quiz_feedback.liked_to_box, ...res.preshipping_quiz_feedback.liked];
          this.$store.commit('setPreshippingStylingFeedback', this.preshippingStylingFeedback);

          if (res.preshipping_comment) {
            this.preshippingComment = res.preshipping_comment
          }

          if (this.colorMapping) {
            if (this.customerInfo.dislikes) {
              this.dislikeColors = this.customerInfo.dislikes.colors.map(color => ({
                ...this.colorMapping[color], name: color
              }))
            } else {
              this.dislikeColors = []
            }
          }
          // hidden/show complete button from outfits API
          this.lastOutfits().then(result => {
            this.isComplete = result
          }).catch(() => {
            this.isComplete = false
          })
        },
        error: err => {
          // Styling fetch failed — updateProducts won't run, so clear the loader
          // here. The Api plugin calls error() with NO argument on a 200 body
          // carrying `error`, hence the err guard.
          this.pageLoading = false
          if (err && err.data && err.data.message) alert(err.data.message)
        }
      })
    },

    currentBox () { // get boxNumber and singleStyles comment
        Vue.api.get(
          `order/${this.orderId}/letter/text`,
          {},
          {
            callback: (data) => {
                this.$store.commit('setLetterText', { stylingBoxNumber: data.current_box_number, stylingSingleComment: data.text['outfit:single:comment'] });
            }
          }
        )
      }
  },
  mounted () {
    this.currentPage = 1
    this.nextPage = false
    this.productsList = []
    window.scrollTo(0, 0)
  },
  created () {
    this.orderId = this.$route.query.id
    this.getOrder(this.orderId).then(res => {
      axios.all([
        Vue.api.get(`/customer/${this.order.customer_id}?format=simple`, {}, {
          callback: res => {
            this.customer = res
          }
        }),
        Vue.api.get('/styling/color-mapping', {}, {
          callback: res => {
            this.colorMapping = res.data
          }
        }),
        Vue.api.get('/styling/product-categories', {}, {
          callback: res => {
            this.stylingProductCategories = res.data
          }
        }),
        Vue.api.get('/styling/size-mapping', {}, {
          callback: res => {
            this.sizeMapping = res.data;
          }
        }),
        Vue.api.get(`/user/${this.order.customer_id}/survey`, {}, {
          callback: res => {
            this.survey = res.data
          }
        }),
        Vue.api.get(`/v2/user/${this.order.customer_id}/comments`, {}, {
          callback: res => {
            this.customerComments = res.data
          }
        }),
        Vue.api.get(`/v2/stylist/${this.order.customer_id}/comments`, {}, {
          callback: res => {
            this.stylistComments = res
          }
        }),
        Vue.api.get(`/v2/order/${this.orderId}/comments`, {}, {
          callback: res => {
            this.orderComments = res.data
          }
        })]
      ).then(result => {
        this.getStyling();
        this.getFeedbackSummary();
        this.currentBox();
      }).catch(() => {
        console.error('Error getting prerequisite data')
        this.pageLoading = false
      })
    }).catch(() => {
      // getOrder failed — drop the loader instead of spinning forever.
      this.pageLoading = false
    })
  }
}

</script>

<style lang="less" scoped>
@import "../styles/variables.less";

@responsive-breakpoint: 1600px;

input[type=checkbox] {
  display: none;
}
.sidebar-toggler {
  position: fixed;
  top: 90px;
  left: 250px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #fff;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all .5s ease;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  z-index: 99;
}

.styling-sidebar-wrapper {
  width: 250px;
  position: fixed;
  top: 60px;
  left: 0;
  bottom: 0;
  overflow-x: hidden;
  overflow-y: scroll;
  transition: all .5s ease;
}

#sidebar-toggle:checked ~ .styling-sidebar-wrapper {
  width: 0;
}
#sidebar-toggle:checked ~ .sidebar-toggler {
  left: 0;
  width: 40px;
  height: 40px;
  transform: rotate(180deg);
}

.topbar-toggler {
  position: fixed;
  top: 490px;
  left: 50%;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #fff;
  transform: translateY(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all .5s ease;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  z-index: 99;

  &.is-new {
    top: 540px;
    @media screen and (max-width: @responsive-breakpoint) {
      top: 480px;
    }
  }
}
.topbar-wrapper {
  background-color: #eee;
  height: 430px;
  padding: 5px 20px 0px 20px;
  position: fixed;
  top: 60px;
  left: 250px;
  right: 0;
  overflow: scroll;
  transition: all .5s ease;
  z-index: 90;
  &.is-new {
    height: 480px;
    @media screen and (max-width: @responsive-breakpoint) {
      height: 420px;
    }
  }
}

#sidebar-toggle:checked ~ .topbar-wrapper {
  left: 0;
}
#topbar-toggle:checked ~ .topbar-wrapper {
  height: 60px;
  mask-image: -webkit-gradient(linear, left 50%, left bottom, from(rgba(0,0,0,1)), to(rgba(0,0,0,0)));

  // #customer-profile is zoomed to 0.85 here, so scale the collapsed height to
  // match — otherwise the fixed 60px reveals an extra row below the tab bar.
  @media screen and (max-width: @responsive-breakpoint) {
    height: 51px;
  }
}
#topbar-toggle:checked ~ .topbar-toggler {
  top: 100px;
  transform: rotate(180deg);
}

.main-wrapper {
  padding: 15px 30px;
  margin-left: 250px;
  margin-top: 450px;
  transition: all .5s ease;
}

#sidebar-toggle:checked ~ .main-wrapper {
  margin-left: 0;
}
#topbar-toggle:checked ~ .main-wrapper {
  margin-top: 30px;
}

/deep/.loader {
  z-index: 102;
}

.product-wrapper {
  width: calc((100vw - 300px) / 10);
  margin-top: 10px;
  margin-bottom: 10px;
  height: 370px;
  max-width: 200px;
}

.viewBoxModalContent{
    width: 50%;
    background: #fff;
    overflow-y: scroll;
    position: relative;
    padding:30px;

    .product-wrapper {
        width: calc((100vw - 100px) / 10);
        @media screen and (max-width: 1200px) {
            width: calc((100vw - 50px) / 6);
        }
        @media screen and (min-width: 1201px) and (max-width: 1500px) {
            width: calc((100vw) / 8.2);
            height: 320px;
            max-width: 200px;
        }

        @media screen and (min-width: 1501px) and (max-width: 1700px) {
            width: calc((100vw - 50px) / 9);
            height: 320px;
            max-width: 200px;
        }
    }
}

::v-deep.modal[name="preshippingFeedbackModal"] {
  z-index: 1001;

  .modal-wrapper{
    width: 95% !important;
    height: 90vh;
    padding-left: 100px;
    padding-right: 100px;
    padding-top: 0px;

  }
  .modal-wrapper .modal-content {
    height: 90%;
    max-height: 90% !important;
  }
}

::v-deep.modal[name=feedbackSummaryModal] .modal-wrapper {
    width: 70vw !important;
    @media screen and (max-width: 1850px) {
        width: 90vw !important;
    }
}
::v-deep.modal[name=stockWarningModal] .modal-wrapper {
  margin-top: 20px;
}
::v-deep.modal[name=preCompleteModal] .modal-wrapper .modal-content,
::v-deep.modal[name=stockWarningModal] .modal-wrapper .modal-content,
::v-deep.modal[name=confirmCompleteModal] .modal-wrapper .modal-content, .modal-content,
::v-deep.modal[name=additionalPSPreCheck] .modal-wrapper .modal-content,
::v-deep.modal[name=bookedCallCheckModal] .modal-wrapper .modal-content,
::v-deep.modal[name=checkRecommenderModal] .modal-wrapper .modal-content,
::v-deep.modal[name=confirmSecondPSModal] .modal-wrapper .modal-content  {
  background: #FFC088;
  border: 3px solid #fff;
  border-radius: 6px;
  overflow: visible;
  padding: 30px 50px;
  overflow-y: auto;
  position: initial;
}

.notify-wrapper {
  position: absolute;
  right: 0;
  top: 20px;
  background: rgba(255, 255, 255, 0.6);
  padding: 10px;
  border-radius: 5px;
  z-index: 99;
  flex-direction: column;
}

.outfit-layout {
  width: 100%;
  padding: 0 20px;

  &--title {
    background: #000c27;
    height: 54px;
    align-items: center;
    margin: 0 -20px;

    span {
      font-size: 26px;
      font-family: @font-primary;
      letter-spacing: 0px;
      color: #FFFFFF;
    }
  }

  &--products {
    padding-bottom: 50px;
    overflow: auto;

    @media screen and (max-width: @responsive-breakpoint) {
      padding-bottom: 40px;
      justify-content: flex-start;
    }

    .outfit-product {
      margin-right: 20px;
      margin-top: 20px;
      box-shadow: 0px 3px 12px #00000029;
      border-radius: 10px;
      padding: 10px;
      background: white;

      .product-brand {
        color: #000000;
        font-size: 14px;
        font-weight: bold;
        text-align: center;
        margin-top: 10px;
        height: 18px;
      }

      .product-image {
        height: 150px;
      }

      .product-price {
        color: #000000;
        font-size: 14px;
        font-weight: 400;
        text-align: center;
      }
    }
  }

  .outfit-description {
    max-width: 50%;
    margin: 50px auto 30px auto;
    font-size: 25px;
    color: #000000;
    font-family: @font-primary;
    text-align: center;
    @media screen and (max-width: @responsive-breakpoint) {
      max-width: 90%;
      margin: 20px auto;
      font-size: 14px;
    }
  }
}

.filteredCategoryProducts {
  display: flex;
  flex-wrap: wrap;
  widows: 200%;

  .mainProdWrapper {
    flex-basis: 11.1111%;
    box-sizing: border-box;
    padding: 10px;
    margin-top: 0;
    margin-bottom: 0;
    height: 400px;
    max-height: none;
    max-width: none;

    @media screen and (max-width: 1000px) {
      flex-basis: 25%;
      padding: 5px;
      height: 260px;
    }

    @media screen and (min-width: 1001px) and (max-width: 1250px) {
      flex-basis: 20%;
      padding: 5px;
      height: 260px;
    }

    @media screen and (min-width: 1251px) and (max-width: 1600px) {
      flex-basis: 16.6667%;
      padding: 5px;
      height: 260px;
    }

    @media screen and (min-width: 1601px) and (max-width: 1950px) {
      flex-basis: 14.28%;
      padding: 7px;
    }

    @media screen and (min-width: 1951px) and (max-width: 2300px) {
      padding: 7px;
    }

    .product-wrapper{
        margin-top: 0px;
        margin-bottom: 0px;
        padding: 5px;
    }
  }
}
</style>
